import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Toolbar,
  useMediaQuery,
  IconButton
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const drawerWidthExpanded = 240;
const drawerWidthCollapsed = 0;

function StickySidebar({ setActiveSection, principalForm }) {
  const [isCollapsed, setIsCollapsed] = useState(true);  // manual collapse toggle
  const isDesktop = useMediaQuery('(min-width:600px)');

  if (!isDesktop) return null;

  const showSidebar =
    principalForm.willAccompanySpouse === "Oui" ||
    principalForm.exceptionalTalent === "Oui";

  if (!showSidebar) return null;

  // Manual click toggle
  const handleCollapseToggle = () => {
    setIsCollapsed(prev => !prev);
  };

  return (
    <Box sx={{ display: 'flex' }}>

      {/* Sidebar Drawer */}
      <Drawer
        variant="permanent"
        onMouseEnter={() => {
          setIsCollapsed(false);   // Expand
        }}

        onMouseLeave={() => {
          setIsCollapsed(true);    // Collapse
        }}

        sx={{
          width: isCollapsed ? drawerWidthCollapsed : drawerWidthExpanded,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: isCollapsed ? drawerWidthCollapsed : drawerWidthExpanded,
            boxSizing: 'border-box',
            position: 'fixed',
            top: 0,
            height: '100vh',
            transition: 'width 0.3s ease',
            overflowX: 'hidden',
          },
        }}
      >
        <Toolbar />
        <List>
          <ListItem onClick={() => setActiveSection('principal')}>
            <ListItemText primary="Principal" />
          </ListItem>

          {principalForm.willAccompanySpouse === "Oui" && (
            <ListItem onClick={() => setActiveSection('spouse')}>
              <ListItemText primary="Conjoint" />
            </ListItem>
          )}

          {principalForm.exceptionalTalent === "Oui" && (
            <ListItem onClick={() => setActiveSection('talent')}>
              <ListItemText primary="Talents d’exception" />
            </ListItem>
          )}

          
          <ListItem onClick={() => setActiveSection('declaration')}>
            <ListItemText primary="Déclaration" />
          </ListItem>
        </List>
      </Drawer>

      {/* Chevron Button */}
      <Box
        onMouseEnter={() => {
          setIsCollapsed(false);   // Expand
        }}
        onMouseLeave={() => {
          setIsCollapsed(true);    // Collapse
        }}
        sx={{
          position: 'fixed',
          top: '50%',
          left: isCollapsed ? drawerWidthCollapsed - 20 : drawerWidthExpanded - 20,
          transform: 'translateY(-50%)',
          zIndex: 1000,
          bgcolor: 'white',
          borderRadius: '50%',
          boxShadow: 2,
        }}
      >
        <IconButton onClick={handleCollapseToggle}>
          {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Box>
    </Box>
  );
}

export default StickySidebar;
